export default __webpack_public_path__ + "static/2-d0a4856f8d762c9b1598a91fb44d4747.jpeg";